<template>
  <article class="auction-close">
    <group gutter="0">
      <selector title="关闭理由" placeholder="请选择" v-model="close_reason_code" :options="closeReason"></selector>
      <selector title="保证金" placeholder="请选择" v-model="penalty_request" :options="amountInfo"></selector>
    </group>
    <group title="备注">
      <x-textarea placeholder="请输入内容（非必填）" class=""
                  ref=autosize v-model="note">
      </x-textarea>
    </group>
    <div class="btn-bottom">
      <div class="btn-fix">
        <a class="btn" @click.stop.prevent="onSubmit">关闭交易</a>
      </div>
    </div>
  </article>
</template>

<script>
import {
  XTextarea,
  Group,
  Selector
} from '@lx-frontend/cvux'
export default {
  components: {
    XTextarea,
    Group,
    Selector
  },
  data() {
    return {
      close_reason_code: null,
      penalty_request: null,
      note: '',
      closeReason: [
        {
          key: 1,
          value: '与买家协商一致'
        },
        {
          key: 2,
          value: '买家违约拒付款'
        },
        {
          key: 3,
          value: '联系不上买家'
        },
        {
          key: 4,
          value: '车辆已出售'
        },
        {
          key: 5,
          value: '其他原因'
        }
      ],
      amountInfo: [
        {
          key: 1,
          value: '要买家赔偿保证金'
        },
        {
          key: 0,
          value: '不要买家保证金'
        }
      ],
      order_id: 0,
      isClicked: false
    }
  },
  created() {
    this.order_id = this.$route.params.order_id
  },
  methods: {
    onSubmit () {
      let _this = this
      if (!_this.close_reason_code) {
        this.showToast('请选择关闭理由')
        return false
      }
      if (_this.penalty_request === null) {
        this.showToast('请选择保证金')
        return false
      }
      if (_this.isClicked) {
        return false
      }
      _this.isClicked = true
      this.$rest.auction.orderClose({
        'close_reason_code': +this.close_reason_code,
        'penalty_request': this.penalty_request,
        'note': this.note
      }, this.order_id).then((res) => {
        if (res.code === 0) {
          this.showToast('提交成功')
          this.$router.push('/auction/orderdetail/' + this.order_id)
        } else {
          this.isClicked = false
          this.showToast(res.message)
        }
      }, (res) => {
        this.isClicked = false
        this.showToast(res.message)
      })
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
</style>
